export default "__VITE_ASSET__CTi$Ea4S__"